module.exports = __webpack_public_path__ + "static/media/gs-user.811c3280.png";